import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getMerchantPaymentMethods = (
  {
    currency,
    isLive,
  }
    : {
      currency: string,
      isLive: boolean,
    }
) => {
  
  const queryParams = {
    currency,
    is_live: isLive,
    is_invoice: true
  };

  return axiosPrivate.get(`/dashboard/api/v1/integrations/next`, { params: queryParams });
};